<div class="mainbox">
  <div
    [class.haserror-gotop]="isshow && txt.touched && txt.invalid"
    (focus)="focusFunction()"
    (click)="focusFunction()"
    (focusout)="focusOutFunction()"
    class="label gotop">
    <label class="txt" [class.lbl]="isshow"> {{ label }}</label>
    <span [class.error]="txt.touched && txt.invalid" class="star" *ngIf="required === true"> * </span>
  </div>
  <div class="inputbox">
    <div [ngClass]="{ 'dp-open': areCalendarsShown }" class="h-100">
      <div class="dp-input-container" [hidden]="componentConfig.hideInputContainer" [attr.data-hidden]="componentConfig.hideInputContainer">
        <i class="icon-calendar_today-f iconcalendar"></i>
        <input
          type="text"
          class="form-control"
          name="{{ name }}"
          [placeholder]="placeholder"
          [(ngModel)]="inputElementValue"
          (ngModelChange)="onViewDateChange($event, input)"
          (focus)="inputFocused()"
          [readonly]="componentConfig.disableKeypress"
          [disabled]="disabled"
          #txt="ngModel"
          #input />

        <div class="error unvisible" [class.visible]="txt.touched && txt.invalid">
          <span [hidden]="!txt.errors?.required"> بازه زمانی را انتخاب نمایید </span>
        </div>
      </div>
      <div #container class="dp-calendar-wrapper">
        <div class="dp-popup {{ theme }}" [ngSwitch]="mode" [hidden]="!_areCalendarsShown" [attr.data-hidden]="!_areCalendarsShown">
          <dp-day-calendar
            #dayCalendar
            *ngSwitchCase="'day'"
            [config]="dayCalendarConfig"
            [ngModel]="_selected"
            [displayDate]="displayDate"
            [theme]="theme"
            (onSelect)="dateSelected($event, 'day')"
            (onGoToCurrent)="onGoToCurrent.emit()"
            (onLeftNav)="onLeftNavClick($event)"
            (onRightNav)="onRightNavClick($event)">
          </dp-day-calendar>

          <dp-month-calendar
            #monthCalendar
            *ngSwitchCase="'month'"
            [config]="dayCalendarConfig"
            [ngModel]="_selected"
            [displayDate]="displayDate"
            [theme]="theme"
            (onSelect)="dateSelected($event, 'month')"
            (onGoToCurrent)="onGoToCurrent.emit()"
            (onLeftNav)="onLeftNavClick($event)"
            (onRightNav)="onRightNavClick($event)">
          </dp-month-calendar>

          <dp-time-select
            #timeSelect
            *ngSwitchCase="'time'"
            [config]="timeSelectConfig"
            [ngModel]="_selected && _selected[0]"
            (onChange)="dateSelected($event, 'second', true)"
            [theme]="theme">
          </dp-time-select>

          <dp-day-time-calendar
            #daytimeCalendar
            *ngSwitchCase="'daytime'"
            [config]="dayTimeCalendarConfig"
            [displayDate]="displayDate"
            [ngModel]="_selected && _selected[0]"
            [theme]="theme"
            (onChange)="dateSelected($event, 'second', true)"
            (onGoToCurrent)="onGoToCurrent.emit()"
            (onLeftNav)="onLeftNavClick($event)"
            (onRightNav)="onRightNavClick($event)">
          </dp-day-time-calendar>
        </div>
      </div>
    </div>
  </div>
</div>
